<div class="scatter-chart-section">
    <div class="chart-container">
        <canvas  id="MyChart">{{ chart }}</canvas>
    </div>
</div>